import { render, staticRenderFns } from "./MailIntegration.vue?vue&type=template&id=c86c6c74"
import script from "./MailIntegration.vue?vue&type=script&lang=js"
export * from "./MailIntegration.vue?vue&type=script&lang=js"
import style0 from "./MailIntegration.vue?vue&type=style&index=0&id=c86c6c74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports